import { useEffect } from "react";
import CmsBanner from "../../components/Banner/CmsBanner";
import BlueBtn from "../../components/button/PrimaryBtn";
import { useCmsPage } from "../../hooks/useCms";
import Loader from "../../components/Loader/Loader";
import { useTranslation } from "react-i18next";
export default function TermsConditions() {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const { page, isLoading, isError } = useCmsPage("terms_conditions");

  useEffect(() => {
    const handleResize = () => {
      const body = document.body;

      if (window.innerWidth >= 2400) {
        body.classList.add("scale-wrapper");
      } else {
        body.classList.remove("scale-wrapper");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isLoading) {
    return (
      <div className="wrapper bg-primary-ivory">
        <CmsBanner
          title={t("termsConditions.title")}
          classNameShape="hidden"
        />
        <section className="lg:py-[7vw] py-10 pb-22 relative  2xl:-mt-[2.24vw] -mt-11 z-10 ">
          <div className="w-full 2xl:max-w-[50vw] max-w-[900px] mx-auto px-4 relative z-20">
            <div className="flex flex-col items-center justify-center py-20">
              <Loader />
              <p className="mt-4 text-gray-600 text-lg font-medium">{t("termsConditions.loading")}</p>
            </div>
          </div>
        </section>
      </div>
    );
  }

  if (isError || !page || !page?.content) {
    return (
      <div className="wrapper bg-primary-ivory">
        <CmsBanner
          title={t("termsConditions.title")}
          classNameShape="hidden"
        />
        <div className="w-full max-w-[900px] fullhd:max-w-[1100px] mx-auto px-4 relative z-20">
          <div className="flex flex-col items-center justify-center py-20">
            <p className="mt-4 text-gray-600 text-lg font-medium">{t("termsConditions.notAvailable")}</p>
            <p className="mt-4 text-gray-600 text-lg font-medium">{t("termsConditions.notAvailableDescription")}</p>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="wrapper bg-primary-ivory">
      <CmsBanner title={page?.title} description={page?.description} classNameShape="hidden" />
      <div className="wrapper">
        <section className="lg:py-[7vw] py-10 pb-22 relative  2xl:-mt-[2.24vw] -mt-11 z-10 ">
          <div className="w-full 2xl:max-w-[50vw] max-w-[900px] mx-auto px-4 relative z-20">
            <div className="">
              <div
                className={`prose max-w-none ${isArabic ? "rtl text-right" : "ltr text-left"}`}
                dir={isArabic ? "rtl" : "ltr"}
              >
                <div dangerouslySetInnerHTML={{ __html: page?.content }} />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
